<template>
  <div class="recipe-chip-list">
    <div class="chip-group">
      <!-- <div v-if="groups.Label" class="group-label">{{ groups.Label }}</div> -->
      <div
        ref="chips"
        class="chips"
        @scroll.passive="updateCarouselControls"
      >
        <button
          v-for="opt in groups.Options"
          :key="opt.Value || opt.Name"
          :class="['chip', { 'is-active': (groups.selectedValues || []).includes(opt.Value || opt.Name) }]"
          :data-initial="(opt.Name || '').charAt(0)"
          type="button"
          @click.prevent="toggleChip(opt)"
        >
          <span class="chip__media" aria-hidden="true">
            <img
              v-if="!missingImages[chipImageKey(opt)]"
              class="chip__image"
              :src="chipImageUrl(opt)"
              :alt="''"
              @error="handleImageError(opt)"
            />
            <span v-else class="chip__initial">{{ (opt.Name || '').charAt(0) }}</span>
          </span>
          {{ opt.Name }}
        </button>
      </div>
      <button
        v-if="canScrollPrevious"
        class="chip-carousel-control chip-carousel-control--previous"
        type="button"
        aria-label="Show previous recipe categories"
        @click="scrollChips(-1)"
      >
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </button>
      <button
        v-if="canScrollNext"
        class="chip-carousel-control chip-carousel-control--next"
        type="button"
        aria-label="Show more recipe categories"
        @click="scrollChips(1)"
      >
        <i class="fas fa-chevron-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';

  export default {
    props: [],
  
    computed: mapState({
      loading: state => state.listing.loading,
      listing: state => state.listing.listing,
      specification: state => state.listing.specification,
      pagination: state => state.listing.pagination,
    }),

    data() {
      return {
        groups: {},
        missingImages: {},
        canScrollPrevious: false,
        canScrollNext: false,
      }
    },

    mounted() {
      // try to read from global RecipeCategories (fallback to hardcoded)
      let source = (typeof window !== 'undefined' && window.Launchpad && window.Launchpad.RecipeCategories) || null;
      if (Array.isArray(source)) {
        source = source[0] || null;
      }

      // shallow copy source into groups (ensure plain object)
      this.groups = Object.assign({}, source);

      // ensure selectedValues array exists for managing active chips (use $set for reactivity)
      this.$set(this.groups, 'selectedValues', []);
      this.initializeSelectedValues();
      this.$nextTick(this.updateCarouselControls);
      window.addEventListener('resize', this.updateCarouselControls);
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.updateCarouselControls);
    },

    watch: {
      specification: {
        handler(newSpec) {
          this.updateSelectedValuesFromSpec(newSpec);
        },
        deep: true,
      }
    },

    methods: {
      initializeSelectedValues() {
        this.groups.selectedValues = this.getSelectedValues(this.specification);
      },
      updateSelectedValuesFromSpec(newSpec) {
        this.groups.selectedValues = this.getSelectedValues(newSpec);
      },
      getSelectedValues(specification) {
        const spec = this.groups.Specification || this.groups.Label;
        const selectedValues = this.getMatchingOptionValues(specification[spec]);

        return selectedValues.length ? selectedValues : this.getMatchingOptionValues(specification.RecipeType);
      },
      ...mapActions('listing', { setFilter: 'setFilter' }),
      ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
      getMatchingOptionValues(values) {
        const selectedValues = Array.isArray(values) ? values : [values];
        const optionValues = (this.groups.Options || []).map(opt => opt.Value || opt.Name);

        return selectedValues.filter(value => optionValues.includes(value));
      },
      chipImageKey(opt) {
        return (opt.Name || opt.Value || '').toString().trim().toLowerCase();
      },
      chipImageUrl(opt) {
        return `/Content/images/Custom/recipeCategories/${encodeURIComponent(this.chipImageKey(opt))}.png`;
      },
      handleImageError(opt) {
        this.$set(this.missingImages, this.chipImageKey(opt), true);
      },
      updateCarouselControls() {
        const chips = this.$refs.chips;
        if (!chips) return;

        const overflow = chips.scrollWidth > chips.clientWidth;
        const maxScrollLeft = chips.scrollWidth - chips.clientWidth;
        this.canScrollPrevious = overflow && chips.scrollLeft > 1;
        this.canScrollNext = overflow && chips.scrollLeft < maxScrollLeft - 1;
      },
      scrollChips(direction) {
        const chips = this.$refs.chips;
        if (!chips) return;

        chips.scrollBy({ left: direction * Math.max(chips.clientWidth * 0.75, 160), behavior: 'smooth' });
      },
      toggleChip(opt) {
        const val = opt.Value || opt.Name;
        const sel = this.groups.selectedValues || [];
        const idx = sel.indexOf(val);
        if (idx === -1) sel.push(val);
        else sel.splice(idx, 1);

        this.$set(this.groups, 'selectedValues', sel);

        const spec = this.groups.Specification || this.groups.Label;
        this.updateSpecification({ key: spec, value: sel });
      }
    }
  }
</script>
